import { AxiosPromise, CancelToken } from "axios";
import { route } from "../../../shim/jsbridge";
import { Visualization } from "../@types";
import { AxiosApiWrapper } from "../../../services/api/AxiosApiWrapper";

class Api extends AxiosApiWrapper {
  getVisualization = (
    hash: string,
    cancelToken: CancelToken
  ): AxiosPromise<Visualization> =>
    this.get(route("api_file_visualization", [hash]), {
      cancelToken
    });

  getExpandedCloudDetails = (hashValue: string) =>
    this.get(
      route("api-sample-expanded-details-cloud", { hash_value: hashValue })
    );

  rescanSampleStatus = (hashValue: string) =>
    this.post(route("rescan_sample_status", { hash_value: hashValue }));

  rescanSample = (hashValue: string) =>
    this.post(route("rescan_sample", { hash_value: hashValue }));
}

export default new Api();
